/**
 * Clip API
 */
import { get } from "axios";

export default {
    /**
     * Get Clip List
     */
    getArticles(param) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}article`,
                params ={
                    lang_id: param.lang_id,
                    article_ids: param.article_ids,
                    token: process.env.UNIQUE_TOKEN
                }

            get(url, {params})
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },

}



// WEBPACK FOOTER //
// ./src/api/articles.js